import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const CreditCardIcon = ({
  style,
  width = '16',
  height = '16',
}: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_1745_10039)">
          <path
            d="M2 5.33594C2 4.8055 2.21071 4.2968 2.58579 3.92172C2.96086 3.54665 3.46957 3.33594 4 3.33594H12C12.5304 3.33594 13.0391 3.54665 13.4142 3.92172C13.7893 4.2968 14 4.8055 14 5.33594V10.6693C14 11.1997 13.7893 11.7084 13.4142 12.0835C13.0391 12.4586 12.5304 12.6693 12 12.6693H4C3.46957 12.6693 2.96086 12.4586 2.58579 12.0835C2.21071 11.7084 2 11.1997 2 10.6693V5.33594Z"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 6.66406H14"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.66602 10H4.67268"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33398 10H8.66732"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1745_10039">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
